<template>
  <div class="body__innner">
    <div id="banner-start" class="fv">
      <AtomsConsumerLink url="#form" class="cta-t">
        <picture class="din-h-men">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/din-h-men.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <AtomsConsumerLink url="#form2" class="cta-t cta-t2">
        <picture class="din-h-women">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/din-h-women.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/fv.png"
          alt="寝て、着るだけBAKUNE"
          class="wi100"
          fetchpriority="high"
          :width="imgWidth"
        />
      </picture>
      <AtomsConsumerLink url="#form" class="cta">
        <div class="cta__inner">
          <div class="cta__t1">
            <span class="cta__t1-w"><span class="t1">2</span><span class="t2">点以上ご購入で</span></span>
            <span class="cta__t1-2-w"><span class="t3">10</span><span class="t4">%OFF</span></span>
          </div>
          <div class="cta__t2">疲労回復パジャマを体感する</div>
        </div>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <AtomsConsumerLink url="#form" class="cta2">
        <picture class="din-h-men">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta2-din-h-men.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <AtomsConsumerLink url="#form2" class="cta2 cta3">
        <picture class="din-h-women">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta2-din-h-women.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
    </div>
    <div class="totalSales">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/100million.png"
          alt="累計販売数100万突破"
          class="wi100"
          :lazy="true"
          :width="imgWidth"
        />
      </picture>
    </div>
    <div class="satisfaction">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/satisfaction.png"
          alt="アスリートが機能性に満足と回答"
          class="wi100"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
    </div>
    <div class="voice">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/voice.png"
          alt="トップアスリートの声"
          class="wi100"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
    </div>
    <div class="production">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/production.png"
          alt="BAKUNE"
          class="wi100"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
      <div class="accordion">
        <div class="accordion__inner">
          <div class="accordion__tiitle">
            <div class="accordion__t1">一般医療機器とは？</div>
            <picture class="accordion__yaji">
              <AtomsConsumerImage
                src="/images/bakune-dry-lp/accordion-yaji.svg"
                alt="yaji"
                class="wi100"
                :width="imgWidth"
              ></AtomsConsumerImage>
            </picture>
          </div>
          <div class="accordion__content">
            一般医療機器は、使用目的に沿って適正に使用されている状況で不具合が生じても、人の生命・健康に与えるリスクが極めて低いと考えられる医療機器を指します。<br /><br />
            BAKUNEでは、厚生労働省における新基準である、一般医療機器「家庭用遠赤外線血行促進用衣」の新カテゴリーに、届出済です。<br /><br />
            品質や安全性の厳しい基準をクリアし、「健康に前向きな社会を創り、人類のポテンシャルを引き出す」をミッションに、コンディショニングブランド「TENTIAL」を展開してまいります。
          </div>
        </div>
      </div>
      <div class="comparison js-scrollable">
        <picture>
          <AtomsConsumerImage
            src="/images/bakune-dry-lp/comparison.png"
            alt="BAKUNE他社比較"
            class="comparison__img"
            :lazy="true"
            :width="imgWidth * 1.15"
            :quality="1"
          ></AtomsConsumerImage>
        </picture>
      </div>
      <div class="secret">
        <picture>
          <AtomsConsumerImage
            src="/images/bakune-dry-lp/secret.png"
            alt="秘訣は・・・"
            class="wi100"
            :width="imgWidth"
            :lazy="true"
          ></AtomsConsumerImage>
        </picture>
      </div>
    </div>
    <div class="point">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/point1.png"
          class="wi100"
          alt="point1"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/point2.png"
          class="wi100"
          alt="point2"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
    </div>
    <div class="present">
      <picture>
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/present.png"
          class="wi100"
          alt="ご家族や大切な人にも安らぎの時間をプレゼント"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
      <div id="modalOpen" class="giftCta">
        <div class="giftCta__inner">
          <div class="giftCta__bd"></div>
          <div class="giftCta__t1">eギフトはこちら</div>
        </div>
      </div>
      <AtomsConsumerLink url="#form" class="cta">
        <div class="cta__inner">
          <div class="cta__t1">
            <span class="cta__t1-w"><span class="t1">2</span><span class="t2">点以上ご購入で</span></span>
            <span class="cta__t1-2-w"><span class="t3">10</span><span class="t4">%OFF</span></span>
          </div>
          <div class="cta__t2">疲労回復パジャマを体感する</div>
        </div>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            src="/images/bakune-dry-lp/cta-yaji.svg"
            alt="yaji"
            class="wi100"
            :lazy="true"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <AtomsConsumerLink url="#form" class="cta2">
        <picture class="din-h-men">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta2-din-h-men.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
      <AtomsConsumerLink url="#form2" class="cta2 cta3">
        <picture class="din-h-women">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta2-din-h-women.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
        <picture class="cta__yaji">
          <AtomsConsumerImage
            :lazy="true"
            src="/images/bakune-dry-lp/cta-yaji2.svg"
            alt="yaji"
            class="wi100"
          ></AtomsConsumerImage>
        </picture>
      </AtomsConsumerLink>
    </div>
    <div class="lineup">
      <div class="lineup__t1">BAKUNEは<br /><span>豊富なラインナップ</span>を<br />展開しています</div>
      <div class="lineup__products js-scrollable">
        <AtomsConsumerLink
          v-for="product in props.lineupProducts"
          :key="product.linkUrl"
          :url="product.linkUrl"
          class="lineup__product"
        >
          <picture class="lineup__product__img">
            <AtomsConsumerImage
              :src="product.imageSrc"
              :alt="product.imageAlt"
              :width="imgWidth"
              :lazy="true"
            ></AtomsConsumerImage>
          </picture>
          <div class="lineup__product__btn">
            <div class="lineup__product__btn-t1">詳しくみる</div>
            <picture class="lineup__cta__yaji">
              <AtomsConsumerImage
                src="/images/bakune-dry-lp/lineup-yaji.svg"
                alt="yaji"
                :width="imgWidth"
                :lazy="true"
              ></AtomsConsumerImage>
            </picture>
          </div>
        </AtomsConsumerLink>
      </div>
      <div class="lineup__btn">
        <AtomsConsumerLink url="#form" class="cta">
          <div class="cta__inner">
            <div class="cta__t1">
              <span class="cta__t1-w"><span class="t1">2</span><span class="t2">点以上ご購入で</span></span>
              <span class="cta__t1-2-w"><span class="t3">10</span><span class="t4">%OFF</span></span>
            </div>
            <div class="cta__t2">疲労回復パジャマを体感する</div>
          </div>
          <picture class="cta__yaji">
            <AtomsConsumerImage
              src="/images/bakune-dry-lp/cta-yaji.svg"
              alt="yaji"
              class="wi100"
              :lazy="true"
            ></AtomsConsumerImage>
          </picture>
        </AtomsConsumerLink>
        <div class="lineup__btn__cta2">
          <AtomsConsumerLink url="#form" class="cta2">
            <picture class="din-h-men">
              <AtomsConsumerImage
                :lazy="true"
                src="/images/bakune-dry-lp/cta2-din-h-men.svg"
                alt="yaji"
                class="wi100"
              ></AtomsConsumerImage>
            </picture>
            <picture class="cta__yaji">
              <AtomsConsumerImage
                :lazy="true"
                src="/images/bakune-dry-lp/cta-yaji2.svg"
                alt="yaji"
                class="wi100"
              ></AtomsConsumerImage>
            </picture>
          </AtomsConsumerLink>
          <AtomsConsumerLink url="#form2" class="cta2 cta3">
            <picture class="din-h-women">
              <AtomsConsumerImage
                :lazy="true"
                src="/images/bakune-dry-lp/cta2-din-h-women.svg"
                alt="yaji"
                class="wi100"
              ></AtomsConsumerImage>
            </picture>
            <picture class="cta__yaji">
              <AtomsConsumerImage
                :lazy="true"
                src="/images/bakune-dry-lp/cta-yaji2.svg"
                alt="yaji"
                class="wi100"
              ></AtomsConsumerImage>
            </picture>
          </AtomsConsumerLink>
        </div>
      </div>
      <picture id="banner-end">
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/sleepEnvironment.png"
          alt="着て、寝るだけで今までにない睡眠環境へ"
          class="wi100"
          :lazy="true"
          :width="imgWidth"
        ></AtomsConsumerImage>
      </picture>
    </div>
    <!-- モーダル -->
    <div id="easyModal" class="modal">
      <div class="modal-content">
        <span class="modalClose js_modalClose"></span>
        <div class="modal-body">
          <h3>eギフトとは？</h3>
          <h4>■ どんなサービス？</h4>
          <p
            >相手の住所を知らなくても、LINEやSNSなどで受け取りURLを送ることでギフトを相手に贈れるサービスです。カラー・サイズは受け取り手に選んでもらえます。
            購入後に発行される、eギフト受け取りURLをお相手の方にLINEやSNSでお送りすることができます。お相手の方は会員登録不要で、住所と商品情報を入力すると商品が届きます。</p
          >
          <p class="c-red"
            >※ 通常購入とeギフトで贈る商品を同時に購入できません。<br />
            ※ eギフトと刺繍サービスを併用で設定する事はできません。<br />
            ※ 予約販売の商品はeギフトで受け取り時に選択ができない商品となります。<br />
            ※
            eギフトをご注文いただいてもラッピング資材は付いておりません。ラッピングをご希望の場合は、商品購入時に予めギフトラッピングを設定の上ご注文をお願いいたします。<br />
            ※
            注文1件につき贈り先は1つとなります。複数贈り先がある場合にはお手数おかけ致しますが、1件ずつご注文をお願いいたします。<br />
            ※ 発行されたURLの受け取り期限は購入より5日後です。<br />
            ※
            受け取りURLの期限（購入後5日後）が過ぎた場合、注文者様の方で受け取り手続きを行う又は、注文をキャンセルいただくことが可能です。</p
          >
          <h4>■ 送り主名について</h4>
          <p
            >eギフト設定時には「贈り主名」の入力が必須となっておりますが、本名ではなくニックネームでも設定可能なため、本名を明かさずに贈ることが可能です。
            <br />お届けする荷物の配送伝票（送り状）にご注文者様のお名前は記載されず、「依頼主:株式会社TENTIAL」と記載された状態でお届けとなります。</p
          >
          <h4>■ メッセージについて</h4>
          <p
            >ご入力頂くメッセージはWEB上でのみ表示される仕様となり、ギフト内に紙面に印刷されたメッセージなどは同封されません。</p
          >
          <h4>■ ご注文から受け取りまでの流れ</h4>
          <div class="modal__p-flex">
            <p class="fs-20">1</p>
            <p class="fs-16">eギフトとして贈りたい商品を、選択して購入します</p>
          </div>
          <div class="modal__p-flex">
            <p class="fs-20">2</p>
            <p class="fs-16">購入後に購入者様宛に届くメールから、受け取りURLをコピーします</p>
          </div>
          <div class="modal__p-flex">
            <p class="fs-20">3</p>
            <p class="fs-16">受け取りURLを家族や友人など、届けたい相手に送ります</p>
          </div>
          <div class="modal__p-flex">
            <p class="fs-20">4</p>
            <p class="fs-16">お相手の方が住所と商品情報を入力すると、ギフトとして商品が届きます</p>
          </div>
          <button class="js_modalClose modal__btn__close">閉じる</button>
        </div>
      </div>
    </div>
    <!-- モーダル終了 -->

    <client-only>
      <PagePartsCart
        v-if="dryMensProductRef"
        id="form"
        :product="dryMensProductRef"
        :list-parts="[]"
        :subtitle="''"
        :description="''"
        :index="0"
        :cart-index="0"
        :page-type="''"
        class="cart"
        :delivery-lt-prefectures="deliveryLtPrefectures"
        :is-product-info-modal="true"
        @open-product-info-modal="openProductInfoModal"
      />
    </client-only>
    <client-only>
      <PagePartsCart
        v-if="dryWomensProductRef"
        id="form2"
        :product="dryWomensProductRef"
        :list-parts="[]"
        :subtitle="''"
        :description="''"
        :index="1"
        :cart-index="1"
        :page-type="''"
        class="cart"
        :delivery-lt-prefectures="deliveryLtPrefectures"
        :is-product-info-modal="true"
        @open-product-info-modal="openProductInfoModal"
      />
    </client-only>
    <footer>
      <div class="footer__icon">
        <picture>
          <AtomsConsumerImage
            src="/images/bakune-dry-lp/f-icon.svg"
            alt="TENTIAL"
            class="wi100"
            :lazy="true"
            :width="95"
          ></AtomsConsumerImage>
        </picture>
      </div>
      <div class="footer__w-t1">
        <AtomsConsumerLink url="https://corp.tential.jp/privacy/" class="footer__t1"
          >プライバシーポリシー</AtomsConsumerLink
        >
        <AtomsConsumerLink url="https://corp.tential.jp/" class="footer__t1">運営会社について</AtomsConsumerLink>
        <AtomsConsumerLink url="https://tential.jp/law_info" class="footer__t1">特定商取引法の表示</AtomsConsumerLink>
        <AtomsConsumerLink url="https://tential.jp/terms" class="footer__t1">利用規約</AtomsConsumerLink>
      </div>
      <div class="footer__line"></div>
      <div class="footer__copyrigh">©2025 TENTIALL</div>
    </footer>
    <div id="easyModalProduction" class="modal modalProduction">
      <div class="modal-content">
        <span class="modalClose js_modalCloseProduction" @click="closeProductInfoModal"></span>
        <div class="modal-body">
          <h4>◎一般的名称</h4>
          <p>家庭用遠赤外線血行促進用衣</p>
          <h4>◎販売名</h4>
          <p>BAKUNE Dry</p>
          <h4>◎医療機器製造販売届出番号</h4>
          <p>13B2X10608000003</p>
          <h4>◎製造販売社情報</h4>
          <p>株式会社TENTIAL<br />〒141-0001<br />東京都品川区北品川六丁目7番29号521号室<br />電話番号：03-6455-2921</p>
          <h4>◎効能・効果</h4>
          <p
            >【使用目的又は効果】遠赤外線の血行促進作用により疲労や筋肉のこり等の症状を改善する。<br />【血行促進作用効果】
            ● 疲労軽減 ● 筋肉のコリ等の改善 ● 疲労回復</p
          >
          <h4>◎性能</h4>
          <p>身体から発する遠赤外線を輻射する素材SELFLAME®を使用。それによる血行促進作用効果。</p>
          <h4>◎禁忌・禁止事項、重要な安全性情報</h4>
          <p
            >・湿疹、かぶれ、傷口等、皮膚に異常がある人は使用しないで下さい。<br />・異常（かゆみ、蕁麻疹などのアレルギー、かぶれなど）を感じたら、ご使用を中止して下さい。</p
          >
          <h4>保管方法</h4>
          <p
            >・直射日光、水濡れ、高温、多湿な環境を避けて保管して下さい。<br />・しばらく使用しない時は一度干してから、湿気のない場所で保管して下さい。</p
          >
          <h4>【使用上の注意】</h4>
          <p
            >●素材の特性上、濃色品は他の物に色移りする恐れが有りますので、他の物と分けて洗って下さい。<br />●湿った状態や、着用中の摩擦により他の物に移染する恐れがありますので、着用には注意して下さい。<br />●素材の特性上、着用、洗濯時の摩擦などにより毛玉が発生する場合があります。その際はお早めに毛玉取り機等で手入れをしてください。</p
          >
          <button class="js_modalCloseProduction modal__btn__close" @click="closeProductInfoModal">閉じる</button>
        </div>
      </div>
    </div>
    <!-- モーダル終了-製品情報 -->
    <!--  離脱ポップアップ -->
    <div class="popup_w-bs">
      <div class="popup_bs">
        <AtomsConsumerLink url="#form" class="popup_close popup_btn" data-action="confirm" @click="handleLeavePage()">
          <ul>
            <div>
              <picture>
                <AtomsConsumerImage
                  src="/images/bakune-dry-lp/ridatuPopup.png"
                  class="wi100"
                  alt="着て、寝るだけで疲労回復BAKUNE"
                  :width="imgWidth"
                  :lazy="true"
                ></AtomsConsumerImage>
              </picture>
            </div>
          </ul>
        </AtomsConsumerLink>
        <button class="popup_close btn-batu" type="button" data-action="cancel" @click="closePopup()">
          <AtomsConsumerImage src="/images/bakune-dry-lp/btn-batu.svg" alt="閉じる"
        /></button>
      </div>
    </div>
    <!--  離脱ポップアップ--終了 -->
    <!--  フローティングバナー-->
    <AtomsConsumerLink id="floatingBanner" url="#form" :class="{ show: bannerVisible }" class="cta floating-banner">
      <div class="cta__inner">
        <div class="cta__t1">
          <span class="cta__t1-w"><span class="t1">2</span><span class="t2">点以上ご購入で</span></span>
          <span class="cta__t1-2-w"><span class="t3">10</span><span class="t4">%OFF</span></span>
        </div>
        <div class="cta__t2">疲労回復パジャマを体感する</div>
      </div>
      <picture class="cta__yaji">
        <AtomsConsumerImage
          src="/images/bakune-dry-lp/cta-yaji.svg"
          alt="yaji"
          class="wi100"
          :lazy="true"
        ></AtomsConsumerImage>
      </picture>
    </AtomsConsumerLink>
    <!--  フローティングバナー -->
  </div>
</template>

<script setup lang="ts">
import { register } from "swiper/element/bundle"
import { useWindowSize } from "@vueuse/core"
import { Product, PublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery } from "~/types/type.generated"
import {
  usePublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery,
  usePublicProductFindOneQuery,
} from "~/gql/urql.generated"
import { BAKUNE_DRY_PRODUCT_IDS, BAKUNE_DRY_LINEUP_PRODUCTS } from "~/const/lp"

/**
 * ラインナップ商品の型定義
 */
interface LineupProduct {
  /** 商品画像のパス */
  imageSrc: string
  /** 商品画像のalt属性 */
  imageAlt: string
  /** 商品詳細ページのURL */
  linkUrl: string
}

/**
 * BakuneDryコンポーネントのProps
 */
interface Props {
  /** メンズ商品のdocument_id */
  mensProductId: string
  /** レディース商品のdocument_id */
  womensProductId: string
  /** ラインナップ商品の配列 */
  lineupProducts: LineupProduct[]
}

const props = withDefaults(defineProps<Props>(), {
  mensProductId: BAKUNE_DRY_PRODUCT_IDS.long.mens,
  womensProductId: BAKUNE_DRY_PRODUCT_IDS.long.womens,
  lineupProducts: () => BAKUNE_DRY_LINEUP_PRODUCTS.short,
})

definePageMeta({ layout: "no-header" })
register()

useHead({
  title: "一般医療機器BAKUNE Dry | パジャマで疲労回復",
  meta: [
    {
      name: "description",
      content:
        "着て、寝るだけ。疲労回復することで健康的な毎日を支える機能性パジャマBAKUNE。2024年8月時点での累計販売数は70万枚突破。体を酷使するトップアスリートの方にもご愛用いただいています。今ならお得なセット割引もご用意！BAKUNEで、今までにない睡眠環境へ。ぜひ、一度着用してみてください！",
    },
    { property: "og:title", content: "一般医療機器BAKUNE | パジャマで疲労回復" },
    { property: "og:description", content: "一般医療機器BAKUNE | パジャマで疲労回復" },
    { property: "og:site_name", content: "一般医療機器BAKUNE | パジャマで疲労回復" },
    { property: "og:type", content: "website" },
    { property: "og:image", content: `/images/bakune-dry-lp/OGP.png` },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "一般医療機器BAKUNE | パジャマで疲労回復" },
    {
      name: "twitter:description",
      content:
        "着て、寝るだけ。疲労回復することで健康的な毎日を支える機能性パジャマBAKUNE。2024年8月時点での累計販売数は70万枚突破。体を酷使するトップアスリートの方にもご愛用いただいています。今ならお得なセット割引もご用意！BAKUNEで、今までにない睡眠環境へ。ぜひ、一度着用してみてください！",
    },
    { name: "twitter:image", content: `/images/bakune-dry-lp/OGP.png` },
  ],
  link: [
    { rel: "stylesheet", href: "https://use.typekit.net/nyl5nzf.css" },
    { rel: "canonical", href: "https://tential.jp/lpnh/bakune-dry-lp-search" },
  ],
})

const { width: windowWidth } = useWindowSize()
const imgWidth = windowWidth.value > 768 ? 750 : windowWidth.value

const bannerVisible = ref(false)
const dryMensProductRef = ref<Product | null>(null)
const dryWomensProductRef = ref<Product | null>(null)
const deliveryLtPrefectures = ref<
  PublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery["publicLogilessOutboundDeliveryCalcDeliveryLtPrefectures"]
>({
  default_prefecture: "",
  prefectures: [],
})

const loadProduct = async () => {
  const [{ data: dryMensProduct }, { data: dryWomensProduct }, { data: calcDeliveryLtPrefecturesData }] =
    await Promise.all([
      usePublicProductFindOneQuery({
        requestPolicy: "network-only",
        variables: {
          filter: {
            document_id: props.mensProductId,
            is_status: true,
          },
        },
      }),
      usePublicProductFindOneQuery({
        requestPolicy: "network-only",
        variables: {
          filter: {
            document_id: props.womensProductId,
            is_status: true,
          },
        },
      }),
      usePublicLogilessOutboundDeliveryCalcDeliveryLtPrefecturesQuery({
        requestPolicy: "cache-first",
      }),
    ])

  dryMensProductRef.value = dryMensProduct?.value?.publicProductFindOne as Product
  dryWomensProductRef.value = dryWomensProduct?.value?.publicProductFindOne as Product
  deliveryLtPrefectures.value = calcDeliveryLtPrefecturesData.value
    ?.publicLogilessOutboundDeliveryCalcDeliveryLtPrefectures ?? {
    default_prefecture: "",
    prefectures: [],
  }
}

const handleScroll = () => {
  const banner = document.getElementById("floatingBanner")
  const fv = document.getElementById("banner-start")
  const footer = document.getElementById("banner-end")

  if (!banner || !fv || !footer) return

  const fvOffset = fv.getBoundingClientRect().bottom + window.pageYOffset
  const footerOffset = footer.getBoundingClientRect().top + window.pageYOffset
  const windowHeight = window.innerHeight
  const scrollPosition = window.pageYOffset

  bannerVisible.value = scrollPosition >= fvOffset && scrollPosition + windowHeight < footerOffset
}

const initializeAccordion = () => {
  const accordionTitles = document.querySelectorAll(".accordion__tiitle")
  accordionTitles.forEach((title) => {
    title.addEventListener("click", () => {
      const content = title.nextElementSibling
      content?.classList.toggle("active")
      title.classList.toggle("active")
    })
  })
}

const initializeModal = () => {
  const buttonOpen = document.getElementById("modalOpen")
  const modal = document.getElementById("easyModal")
  const closeButtons = document.querySelectorAll(".js_modalClose")

  buttonOpen?.addEventListener("click", () => {
    if (modal) modal.style.display = "block"
  })

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (modal) modal.style.display = "none"
    })
  })

  addEventListener("click", (e) => {
    if (e.target === modal && modal) {
      modal.style.display = "none"
    }
  })
}

const initializeSmoothScroll = () => {
  const links = document.querySelectorAll('a[href^="#"]')
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()
      const targetId = link.getAttribute("href") // アロー関数でスコープを固定
      const targetElement = document.querySelector(targetId as string)
      if (targetElement) {
        window.scrollTo({
          // @ts-ignore
          top: targetElement.offsetTop,
          behavior: "smooth",
        })
      }
    })
  })
}

const showPopup = ref(false)

// いつ出現させるのか確認する
// const showPopupHandler = () => {
//   showPopup.value = true;
//   document.documentElement.classList.add('popup-body-bc-active');
// };

const closePopup = () => {
  showPopup.value = false
  document.documentElement.classList.remove("popup-body-bc-active")
}

const handleDocumentClick = (event: MouseEvent) => {
  if (!(event.target as HTMLElement).closest(".popup_bs")) {
    closePopup()
  }
}

const handleLeavePage = () => {
  closePopup()
}

const openProductInfoModal = () => {
  const modalProduction = document.getElementById("easyModalProduction")
  if (modalProduction) modalProduction.style.display = "block"
}

const closeProductInfoModal = () => {
  const modalProduction = document.getElementById("easyModalProduction")
  if (modalProduction) modalProduction.style.display = "none"
}

onMounted(() => {
  loadProduct()
  initializeAccordion()
  initializeModal()
  initializeSmoothScroll()

  window.addEventListener("scroll", handleScroll)

  if (sessionStorage.getItem("isFirstLoad") === null) {
    history.replaceState(null, document.title, window.location.href)
    history.pushState(null, document.title, window.location.href)
    sessionStorage.setItem("isFirstLoad", "true")
  }

  // window.addEventListener('popstate', showPopupHandler);
  document.addEventListener("click", handleDocumentClick)
})

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll)
  // window.removeEventListener('popstate', showPopupHandler);
  document.removeEventListener("click", handleDocumentClick)
})
</script>

<style scoped lang="scss">
/* reset-css */
/**/
/* ================================== */
/*             reset.css              */
/* ================================== */
/*
html5doctor.com Reset Stylesheet
v1.6.1
Last Updated: 2010-09-17
Author: Richard Clark - http://richclarkdesign.com
Twitter: @rich_clark
*/

/*要素のフォントサイズやマージン・パディングをリセットしています*/
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  /*font-size:100%;*/
  vertical-align: baseline;
}
/*行の高さをフォントサイズと同じにしています*/
body {
  line-height: 1;
}

/*新規追加要素のデフォルトはすべてインライン要素になっているので、section要素などをブロック要素へ変更しています*/
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

/*nav要素内ulのマーカー（行頭記号）を表示しないようにしています*/
/*nav ul {
    list-style:none;
}*/
ol,
ul {
  list-style: none;
}

/*引用符の表示が出ないようにしています*/
blockquote,
q {
  quotes: none;
}

/*blockquote要素、q要素の前後にコンテンツを追加しないように指定しています*/
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

/*a要素のフォントサイズなどをリセットしフォントの縦方向の揃え位置を親要素のベースラインに揃えるようにしています*/
a {
  margin: 0;
  padding: 0;
  font-size: 100%;
  vertical-align: baseline;
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: solid;
}

/*リンクの色*/
a:link {
  color: inherit;
}
/*訪問済みリンクの色*/
a:visited {
  color: inherit;
}
/*マウスオン時のリンクの色*/
a:hover {
  color: inherit;
}
/*クリックしている時のリンクの色*/
a:active {
  color: inherit;
}

/* ins要素のデフォルトをセットし、色を変える場合はここで変更できるようにしています */
ins {
  background-color: #ff9;
  color: #000;
  text-decoration: none;
}

/* mark要素のデフォルトをセットし、色やフォントスタイルを変える場合はここで変更できるようにしています
また、mark要素とは、文書内の検索結果で該当するフレーズをハイライトして、目立たせる際に使用するようです。*/
mark {
  background-color: #ff9;
  color: #000;
  font-style: italic;
  font-weight: bold;
}

/*テキストに打ち消し線が付くようにしています*/
del {
  text-decoration: line-through;
}

/*IEではデフォルトで点線を下線表示する設定ではないので、下線がつくようにしています
また、マウスオーバー時にヘルプカーソルの表示が出るようにしています*/
abbr[title],
dfn[title] {
  border-bottom: 1px dotted;
  cursor: help;
}

/*隣接するセルのボーダーを重ねて表示し、間隔を0に指定しています*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*水平罫線のデフォルトである立体的な罫線を見えなくしています*/
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #cccccc;
  margin: 1em 0;
  padding: 0;
}

/*縦方向の揃え位置を中央揃えに指定しています*/
input,
select {
  vertical-align: middle;
}

/*画像を縦に並べた時に余白が出ないように*/
img {
  vertical-align: top;
  font-size: 0;
  line-height: 0;
}

/*box-sizingを全ブラウザに対応*/
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
/* submit IOS リセット */
.form input[type="submit"] {
  -webkit-appearance: none;
  border-radius: 0;
}
input[type="radio" i] {
  margin: initial;
}
button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
}
/* pc,sp表示切り替え */
.pc {
  display: block;
}
.sp {
  display: none;
}

.pc780 {
  display: block;
}
.sp780 {
  display: none;
}

@media screen and (max-width: 780px) {
  .pc780 {
    display: none;
  }
  .sp780 {
    display: block;
  }
}

@media screen and (max-width: 768px) {
  .pc {
    display: none;
  }
  .sp {
    display: block;
  }
}
.cart {
  padding: 0 1rem;
  :deep(.wrapping_button_area) {
    flex-direction: column !important;
  }
  :deep(.e_gift_button) {
    max-width: 100% !important;
  }
  :deep(*) {
    line-height: 1.5;
  }
}

/* main */
.body__innner {
  font-size: 62.5%;
  margin: 0 auto;
  max-width: 750px;
  width: 100%;
  overflow: hidden;
  line-height: 1;
  :deep(.swiper) {
    padding-bottom: 33px !important;
    .sample-slider {
      margin: 0 auto;
    }
    .swiper-initialized {
      padding-bottom: 10px !important;
    }
    .swiper-slide {
      width: 87% !important;
      margin: 0 auto;
    }
    .swiper-slide img {
      width: 100%;
    }
    .slide-pagination-wrapper {
      display: flex;
      justify-content: center;
    }
    .swiper-pagination {
      position: static !important;
    }
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      width: auto !important;
    }
    .swiper-pagination-bullets {
      display: flex;
      align-items: center;
    }
    .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-button-prev {
      cursor: pointer;
    }
    .swiper-button-next {
      cursor: pointer;
    }
    .swiper-button-prev,
    .swiper-button-next {
      position: static !important;
      margin-top: initial !important;
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      display: none !important;
    }
    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 7px) !important;
    }
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background: #5d4c3c !important;
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: 15px !important;
      height: 15px !important;
      font-size: 15px;
      color: #bababa !important;
    }
    .swiper-pagination-bullet {
      width: 4px !important;
      height: 4px !important;
    }
  }
}
.wi100 {
  width: 100%;
}

/* fv */
.fv {
  position: relative;
}
.cta__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 23px;
}
.cta {
  background-color: #284b7d;
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  min-height: 172px;
  border-radius: 11.5px;
  box-shadow: 0px 4px 0px #003152;
  transition: 0.2s;
  cursor: pointer;
  position: relative;
  display: block;
}
.fv .cta {
  position: absolute;
  left: 50%;
  bottom: 222px;
  transform: translateX(-50%);
}
.cta:hover {
  box-shadow: unset;
  transform: translateY(4px);
  opacity: 0.7;
}
.fv .cta:hover {
  box-shadow: unset;
  transform: translateX(-50%) translateY(4px);
  opacity: 0.7;
}
.cta:hover .cta__yaji {
  right: 21px;
}
.cta__t1-w {
  text-decoration: underline #fff;
  text-underline-offset: 8px;
}
.cta .t1 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 600;
  font-size: 42px;
  color: #fff;
}
.cta .t2 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 600;
  font-size: 32px;
  color: #fff;
}
.cta .t3 {
  font-family: "din-2014", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #e4c9a5;
  font-size: 86px;
  letter-spacing: -0.07em;
}
.cta .t4 {
  font-family: "din-2014", sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #e4c9a5;
  font-size: 62px;
  margin-left: 0.2em;
}
.cta .cta__t2 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 400;
  font-size: 28px;
  color: #fff;
  text-align: center;
}
.cta .cta__t1 {
  display: flex;
  align-items: flex-end;
}
.cta__t1-2-w {
  transform: translateY(20px);
}
.cta__yaji {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 26px;
  transition: 0.2s;
}

/* totalSales__video */
.totalSales {
  position: relative;
}
.totalSales__video {
  aspect-ratio: 16 / 9;
  width: 87%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 90px;
}
.totalSales__video iframe {
  width: 100%;
  height: 100%;
}

/* production */
.production {
  margin-top: -2.7%;
  position: relative;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(249, 249, 249, 1) 20%,
    rgba(249, 249, 249, 1) 100%
  );
}
.accordion {
  width: 87%;
  margin: 0 auto;
  z-index: 5;
  margin-top: -10%;
  padding-bottom: 20px;
  position: relative;
}
.accordion__tiitle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  background-color: #e4c9a5;
  box-shadow: 0px 4px 16px #00000032;
  border-radius: 8px;
  min-height: 68px;
  position: relative;
  cursor: pointer;
  transition: 0.2s;
}
.accordion__t1 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 700;
  font-size: 41px;
  color: #6b594b;
  text-align: center;
}
.accordion__content {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: #675830;
  line-height: 1.75em;
  padding: 47px 44.5px;
  border: 2px solid #b0943f;
  border-bottom-right-radius: 37px;
  border-bottom-left-radius: 37px;
  margin-top: -1%;
  display: none;
  border-top: none;
  background-color: #faf4ed;
  letter-spacing: -0.04em;
}
.accordion__content.active {
  display: block;
}
.accordion__tiitle:hover {
  opacity: 0.7;
}
.accordion__tiitle.active .accordion__yaji {
  transform: rotate(180deg);
}
.accordion__yaji {
  transition: 0.2s;
}
.comparison {
  padding-left: 5.5%;
  padding-right: 5.5%;
  overflow-x: auto;
  padding-bottom: 40px;
}

/* secret */

/* voice2 */
.voice2 {
  background: rgb(255, 252, 247);
  background: linear-gradient(180deg, rgba(255, 252, 247, 1) 86%, rgba(255, 255, 255, 1) 100%);
  padding-bottom: 127px;
}
.voice2__title {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #5d4c3c;
  text-align: center;
  padding-top: 68px;
  padding-bottom: 20px;
  letter-spacing: 0.15em;
  line-height: 1.75;
}

/* present */
.present {
  position: relative;
}
.present .cta {
  position: absolute;
  left: 50%;
  bottom: 17%;
  transform: translateX(-50%);
}
.present .cta:hover {
  box-shadow: unset;
  transform: translateX(-50%) translateY(4px);
  opacity: 0.7;
}
.present .cta2 {
  bottom: 5.5%;
  box-shadow: 5.5px 5.5px #3b4b5f;
}

.giftCta {
  width: 100%;
  margin: 0 auto;
  min-height: 120px;
  border: 2px solid #284b7d;
  transition: 0.2s;
  cursor: pointer;
  border-radius: 8px;

  position: absolute;
  left: 50%;
  bottom: 30%;
  transform: translateX(-50%);
  background-color: #284b7d84;
  max-width: 640px;
}
.present .giftCta:hover {
  opacity: 0.7;
}
.giftCta__bd {
  max-width: 140px;
  width: 100%;
  height: 2px;
  background-color: #284b7d;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.giftCta__t1 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 600;
  font-size: 32px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.08em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* lineup */
.lineup__t1 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 600;
  font-size: 48px;
  color: #284b7d;
  text-align: center;
  padding-top: 88px;
  padding-bottom: 24px;
  letter-spacing: 0;
  line-height: 1.5;
}
.lineup__t1 span {
  position: relative;
  z-index: 5;
  font-weight: 600;
  color: #284b7d;
}
.lineup__t1 span::before {
  content: "";
  display: block;
  background-color: #e4c9a5;
  width: 102%;
  height: 60%;
  position: absolute;
  z-index: -1;
  left: -2%;
  bottom: -10%;
}
.lineup__products {
  display: flex;
  gap: 48px;
  position: relative;
  overflow: auto;
  padding-left: 5.5%;
  padding-right: 5.5%;
  margin-bottom: 33px;
}
.lineup__product__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
}
.lineup__product__btn-t1 {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #284b7d;
  letter-spacing: 0;
}
.lineup__product {
  position: relative;
}
.lineup__product__btn {
  position: absolute;
  bottom: 15.4px;
  right: 15px;
  max-width: 200px;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  height: 62px;
  transition: 0.2s;
}
.lineup__product {
  transition: 0.2s;
}
.lineup__product:hover {
  opacity: 0.7;
}
.lineup__product:hover .lineup__cta__yaji {
  transform: translateX(4px);
}

.lineup__cta__yaji {
  max-width: 19px;
  width: 100%;
  transition: 0.2s;
}
.lineup__cta__yaji img {
  max-width: 19px;
  width: 100%;
}
.lineup__btn {
  position: relative;
}
.lineup__btn .cta2 {
  position: relative;
  bottom: 0;
  left: 0;
}
.lineup__btn .cta3 {
  position: relative;
  right: 0;
}
.lineup__btn__cta2 {
  display: flex;
  gap: 28px;
  justify-content: center;
  padding-top: 23px;
}

/* modal */
.modal {
  display: none;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(40, 75, 125, 0.85);
}

.modal-content {
  background-color: #fff;
  height: 100svh;
  width: 100%;
  max-width: 1096px;
  animation-name: modalopen;
  animation-duration: 1s;
  padding: 4.8rem;
  margin: 0 auto;
  border-radius: 1.6rem;
  position: relative;
  overflow: auto;
}

.comparison__img {
  max-width: 862px;
}

.lineup__product .lineup__product__img img {
  max-width: 516px;
}

@keyframes modalopen {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-header h1 {
  margin: 1rem 0;
}

.modal-header {
  background: lightblue;
  padding: 3px 15px;
  display: flex;
  justify-content: space-between;
}

.modalClose {
  font-size: 20rem;
  position: absolute;
  right: 2rem;
  top: 2rem;
  padding: 1rem;
}
.modalClose::after {
  transform: rotate(45deg);
  background: #284b7d;
  content: "";
  height: 1px;
  width: 2rem;
  position: absolute;
  left: 0;
  top: 1.165rem;
}
.modalClose::before {
  transform: rotate(-45deg);
  background: #284b7d;
  content: "";
  height: 1px;
  width: 2rem;
  position: absolute;
  left: 0;
  top: 1.165rem;
}

.modalClose:hover {
  cursor: pointer;
}
.modal h3 {
  font-size: 18.72px;
  padding-bottom: 16px;
  line-height: 1.8;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 700;
  color: #18181b;
}
.modal h4 {
  font-size: 16px;
  padding-bottom: 16px;
  line-height: 1.8;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 700;
  color: #18181b;
}
.modal p {
  font-size: 14px;
  padding-bottom: 16px;
  line-height: 1.8;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 500;
  color: #18181b;
}
.modal .c-red {
  color: #cb4252;
}
.modal .modal__p-flex {
  display: flex;
  gap: 16px;
  padding-bottom: 0;
}
.modal .modal__p-flex p {
  padding-bottom: 0;
}
.modal .fs-20 {
  font-size: 20px;
}
.modal .fs-16 {
  font-size: 16px;
  padding-top: 0.4rem;
}
.modal__btn__close {
  background-color: #fff;
  border: 1px solid #d4dbe5;
  border-radius: 0.4rem;
  color: #284b7d;
  padding: 0.6rem 2rem;
  width: 100%;
  margin-top: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: 16px;
}
.modal__btn__close:hover {
  background-color: #284b7d1a;
}
/* 離脱ポップアップ */
.popup_bs {
  display: none;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border-radius: 10px;
  max-width: 750px;
  width: 100%;
}
.popup-body-bc-active .popup_w-bs {
  width: 100vw;
  height: 100svh;
  position: fixed;
  top: 0;
  left: 0;
  background: #000000a8;
  z-index: 999;
  overflow: auto;
}
.popup-body-bc-active {
  background-color: #00000045;
  overflow: hidden;
}
.popup-body-bc-active .popup_bs {
  display: block;
}
.popup_bs .btn-batu {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 15px;
  right: 15px;
  transition: 0.2s;
}
.popup_bs .btn-batu img {
  width: 100%;
  height: 100%;
}
.popup_bs .btn-batu:hover {
  opacity: 0.4;
}
.popup_bs .popup_btn {
  cursor: pointer;
}

/* フローティングバナー */
.floating-banner {
  position: fixed;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  width: 100%;
  opacity: 0;
  transition: 0.5s;
  z-index: 98;
  pointer-events: none;
}
.floating-banner img {
  width: 100%;
}
.floating-banner.show {
  opacity: 1;
  pointer-events: auto;
}
.floating-banner.cta:hover {
  box-shadow: unset;
  opacity: 0.7;
  transform: translateX(-50%);
}

/* footer */
footer {
  background-color: #bbcbdf;
  padding-bottom: 64px;
  padding-top: 64px;
  padding-bottom: 64px;
}
.footer__icon {
  max-width: 95px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1.6rem;
}
.footer__t1 {
  font-size: 20px;
  padding-bottom: 8px;
  line-height: 1.8;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 500;
  color: #284b7d !important;
  display: block;
  text-decoration: underline;
  text-align: left;
}
.footer__line {
  height: 1px;
  width: 90%;
  margin: 0 auto;
  background-color: #7898c0;
  margin-top: 10px;
}
.footer__copyrigh {
  font-size: 16px;
  padding-top: 24px;
  line-height: 1.8;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: 300;
  color: #284b7d !important;
  display: block;
  text-align: center;
}
.footer__w-t1 {
  max-width: fit-content;
  width: 100%;
  margin: 0 auto;
}

.modalProduction h4 {
  padding-bottom: 0;
}
.production__t1 {
  font-family: Helvetica, neue-haas-grotesk-display, Noto Sans JP, YuGothic, Yu Gothic, Hiragino Kaku Gothic ProN,
    sans-serif;
  font-weight: 500;
  color: #18181b !important;
  line-height: 1.5;
  font-size: 1rem;
}
.production__t1-span {
  text-decoration: underline;
  cursor: pointer;
}

/* fv-t-btn */
.cta-t {
  background-color: #e4c9a5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  gap: 8px;
  position: absolute;
  top: 20px;
  right: 220px;
  width: 180px;
  min-height: 94px;
  transition: 0.2s;
  box-shadow: 3.5px 3.5px #001829;
}
.cta-t2 {
  padding-left: 16px;
  gap: 8px;
  right: 22px;
  width: 180px;
}
.cta-t:hover {
  opacity: 0.7;
}
.cta-t:hover .cta__yaji {
  transform: translateX(4px);
}
.cta-t .cta__t2 {
  font-family: "din-2014", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
  color: #2a313b;
  letter-spacing: 0.03em;
}
.cta-t .cta__t2 span {
  font-size: 26px;
}
.cta-t .cta__yaji {
  max-width: 24px;
  width: 100%;
  position: relative;
  top: auto;
  transform: none;
  right: 0px;
  transition: 0.2s;
}
.cta-t2 .cta__yaji {
  max-width: 24px;
  width: 100%;
  position: absolute;
  top: 51.5px;
  transform: none;
  right: 25px;
  transition: 0.2s;
}
.cta-t .cta__inner {
  display: block;
}
.cta-t .din-h-men {
  max-width: 110px;
  width: 100%;
}
.cta-t .din-h-women {
  max-width: 164px;
  width: 100%;
}

/* cta2 */
.cta2 {
  background-color: #e4c9a5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: absolute;
  bottom: 49px;
  left: 63px;
  width: 290px;
  min-height: 150px;
  transition: 0.2s;
  box-shadow: 5.5px 5.5px #7e7c79;
}
.cta3 {
  justify-content: flex-start;
  padding-left: 24px;
  gap: 8px;
  left: auto;
  right: 79px;
}
.cta2:hover {
  opacity: 0.7;
}
.cta2:hover .cta__yaji {
  transform: translateX(4px);
}
.cta2 .cta__yaji {
  max-width: 30px;
  width: 100%;
  position: relative;
  top: auto;
  transform: none;
  right: 0px;
  transition: 0.2s;
}
.cta2 .din-h-men {
  max-width: 176px;
  width: 100%;
}
.cta2 .din-h-women {
  max-width: 263px;
  width: 100%;
}
.cta3 .cta__yaji {
  position: absolute;
  top: 87px;
  transform: none;
  right: 25px;
  transition: 0.2s;
}

@media screen and (max-width: 750px) {
  /* fv */
  .cta__inner {
    gap: calc(23vw / 750 * 100);
  }
  .cta {
    max-width: calc(640vw / 750 * 100);
    min-height: calc(172vw / 750 * 100);
    border-radius: calc(11.5vw / 750 * 100);
    box-shadow: 0px calc(4vw / 750 * 100) 0px #003152;
  }
  .fv .cta {
    bottom: calc(222vw / 750 * 100);
  }
  .cta:hover {
    transform: translateY(calc(4vw / 750 * 100));
  }
  .fv .cta:hover {
    transform: translateX(-50%) translateY(calc(4vw / 750 * 100));
  }
  .cta:hover .cta__yaji {
    right: calc(21vw / 750 * 100);
  }
  .cta__t1-w {
    text-underline-offset: calc(8vw / 750 * 100);
  }
  .cta .t1 {
    font-size: calc(42vw / 750 * 100);
  }
  .cta .t2 {
    font-size: calc(32vw / 750 * 100);
  }
  .cta .t3 {
    font-size: calc(86vw / 750 * 100);
  }
  .cta .t4 {
    font-size: calc(62vw / 750 * 100);
  }
  .cta .cta__t2 {
    font-size: calc(28vw / 750 * 100);
  }
  .cta__t1-2-w {
    transform: translateY(calc(20vw / 750 * 100));
  }
  .cta__yaji {
    right: calc(26vw / 750 * 100);
  }

  /* totalSales__video */
  .totalSales__video {
    bottom: calc(90vw / 750 * 100);
  }

  /* production */
  .accordion {
    padding-bottom: calc(20vw / 750 * 100);
  }
  .accordion__tiitle {
    gap: calc(32vw / 750 * 100);
    box-shadow: 0px calc(4vw / 750 * 100) calc(16vw / 750 * 100) #00000032;
    border-radius: calc(8vw / 750 * 100);
    min-height: calc(68vw / 750 * 100);
  }
  .accordion__t1 {
    font-size: calc(41vw / 750 * 100);
  }
  .accordion__content {
    font-size: calc(22vw / 750 * 100);
    padding: calc(47vw / 750 * 100) calc(44.5vw / 750 * 100);
    border: calc(2vw / 750 * 100) solid #b0943f;
    border-bottom-right-radius: calc(37vw / 750 * 100);
    border-bottom-left-radius: calc(37vw / 750 * 100);
  }
  .comparison {
    padding-bottom: calc(40vw / 750 * 100);
  }
  .comparison__img {
    width: calc(862vw / 750 * 100);
  }

  /* voice2 */
  .voice2 {
    padding-bottom: calc(127vw / 750 * 100);
  }
  .voice2__title {
    font-size: calc(16vw / 750 * 100);
    padding-top: calc(68vw / 750 * 100);
    padding-bottom: calc(20vw / 750 * 100);
  }
  .swiper {
    padding-bottom: calc(56vw / 750 * 100) !important;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, calc(7vw / 750 * 100)) !important;
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: calc(15vw / 750 * 100) !important;
    height: calc(15vw / 750 * 100) !important;
    font-size: calc(15vw / 750 * 100);
  }
  .swiper-pagination-bullet {
    width: calc(4vw / 750 * 100) !important;
    height: calc(4vw / 750 * 100) !important;
  }
  .body__innner {
    :deep(.swiper) {
      padding-bottom: calc(33vw / 750 * 100) !important;
      .swiper-initialized {
        padding-bottom: calc(10vw / 750 * 100) !important;
      }
    }
  }

  /* present */
  .present .cta {
    box-shadow: 0px calc(4vw / 750 * 100) 0px #000f1a;
    max-width: calc(640vw / 750 * 100);
  }
  .present .cta:hover {
    transform: translateX(-50%) translateY(calc(4vw / 750 * 100));
  }
  .giftCta {
    min-height: calc(120vw / 750 * 100);
    max-width: calc(640vw / 750 * 100);
    border: calc(2vw / 750 * 100) solid #284b7d;
    border-radius: calc(8vw / 750 * 100);
  }
  .giftCta__bd {
    max-width: calc(140vw / 750 * 100);
    height: calc(2vw / 750 * 100);
  }
  .giftCta__t1 {
    font-size: calc(32vw / 750 * 100);
  }

  /* lineup */
  .lineup__t1 {
    font-size: calc(48vw / 750 * 100);
    padding-top: calc(88vw / 750 * 100);
    padding-bottom: calc(24vw / 750 * 100);
  }
  .lineup__products {
    gap: calc(48vw / 750 * 100);
    margin-bottom: calc(33vw / 750 * 100);
  }
  .lineup__product__btn {
    gap: calc(11vw / 750 * 100);
  }
  .lineup__product__btn-t1 {
    font-size: calc(18vw / 750 * 100);
  }
  .lineup__product__btn {
    bottom: calc(15.4vw / 750 * 100);
    right: calc(15vw / 750 * 100);
    max-width: calc(200vw / 750 * 100);
    border-radius: calc(6vw / 750 * 100);
    height: calc(62vw / 750 * 100);
  }
  .lineup__cta__yaji {
    max-width: calc(19vw / 750 * 100);
  }
  .lineup__cta__yaji img {
    max-width: calc(19vw / 750 * 100);
  }
  .lineup__product {
    width: calc(516vw / 750 * 100);
  }
  .lineup__product .lineup__product__img {
    width: calc(516vw / 750 * 100);
  }
  .lineup__product .lineup__product__img img {
    width: calc(516vw / 750 * 100);
  }
  .lineup__btn__cta2 {
    gap: calc(28vw / 750 * 100);
    padding-top: calc(23vw / 750 * 100);
  }

  /* modal */
  .modal-content {
    padding: calc(16vw / 750 * 100);
    border-radius: calc(16vw / 750 * 100);
  }
  .modal-header h1 {
    margin: calc(1vw / 750 * 100) 0;
  }
  .modal-header {
    padding: calc(3vw / 750 * 100) calc(15vw / 750 * 100);
  }
  .modalClose {
    font-size: calc(32vw / 750 * 100);
    right: calc(32vw / 750 * 100);
    top: calc(32vw / 750 * 100);
    padding: calc(16vw / 750 * 100);
  }
  .modalClose::after {
    height: calc(1vw / 750 * 100);
    width: calc(32vw / 750 * 100);
    top: calc(11.65vw / 750 * 100);
  }
  .modalClose::before {
    height: calc(1vw / 750 * 100);
    width: calc(33.2vw / 750 * 100);
    top: calc(11.65vw / 750 * 100);
  }
  .modal h3 {
    font-size: calc(18.72vw / 750 * 100);
    padding-bottom: calc(16vw / 750 * 100);
  }
  .modal h4 {
    font-size: calc(16vw / 750 * 100);
    padding-bottom: calc(16vw / 750 * 100);
  }
  .modal p {
    font-size: calc(14vw / 750 * 100);
    padding-bottom: calc(16vw / 750 * 100);
  }
  .modal .modal__p-flex {
    gap: calc(16vw / 750 * 100);
  }
  .modal .fs-20 {
    font-size: calc(20vw / 750 * 100);
  }
  .modal .fs-16 {
    font-size: calc(16vw / 750 * 100);
    padding-top: calc(4vw / 750 * 100);
  }
  .modal__btn__close {
    border: calc(1vw / 750 * 100) solid #d4dbe5;
    border-radius: calc(4vw / 750 * 100);
    padding: calc(12vw / 750 * 100) calc(32vw / 750 * 100);
    margin-top: calc(16vw / 750 * 100);
    font-size: calc(16vw / 750 * 100);
  }
  /* 離脱ポップアップ */
  .popup_bs {
    display: none;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  /* footer */
  footer {
    padding-bottom: calc(64vw / 750 * 100);
    padding-top: calc(64vw / 750 * 100);
    padding-bottom: calc(80vw / 750 * 100);
  }
  .footer__icon {
    max-width: calc(95vw / 750 * 100);
    margin-bottom: calc(24vw / 750 * 100);
  }
  .footer__t1 {
    font-size: calc(23vw / 750 * 100);
    padding-bottom: calc(14vw / 750 * 100);
  }
  .footer__copyrigh {
    font-size: calc(16vw / 750 * 100);
    padding-top: calc(24vw / 750 * 100);
  }
  .footer__w-t1 {
    max-width: calc(248vw / 750 * 100);
  }

  /* fv-t-btn */
  .cta-t {
    border-radius: calc(10vw / 750 * 100);
    padding-left: calc(24vw / 750 * 100);
    gap: calc(8vw / 750 * 100);
    top: calc(20vw / 750 * 100);
    right: calc(220vw / 750 * 100);
    width: calc(180vw / 750 * 100);
    min-height: calc(94vw / 750 * 100);
    box-shadow: calc(3.5vw / 750 * 100) calc(3.5vw / 750 * 100) #001829;
  }
  .cta-t2 {
    padding-left: calc(16vw / 750 * 100);
    gap: calc(8vw / 750 * 100);
    right: calc(22vw / 750 * 100);
    width: calc(180vw / 750 * 100);
  }
  .cta-t .cta__yaji {
    max-width: calc(24vw / 750 * 100);
  }
  .cta-t2 .cta__yaji {
    max-width: calc(24vw / 750 * 100);
    top: calc(51.5vw / 750 * 100);
    right: calc(25vw / 750 * 100);
  }
  .cta-t .cta__t2 {
    font-size: calc(32vw / 750 * 100);
  }
  .cta-t .cta__t2 span {
    font-size: calc(26vw / 750 * 100);
  }
  .cta-t .din-h-men {
    max-width: calc(110vw / 750 * 100);
  }
  .cta-t .din-h-women {
    max-width: calc(164vw / 750 * 100);
  }

  /* cta2 */
  .cta2 {
    border-radius: calc(10vw / 750 * 100);
    gap: calc(10vw / 750 * 100);
    bottom: calc(49vw / 750 * 100);
    left: calc(63vw / 750 * 100);
    width: calc(290vw / 750 * 100);
    min-height: calc(150vw / 750 * 100);
    box-shadow: calc(5.5vw / 750 * 100) calc(5.5vw / 750 * 100) #7e7c79;
  }
  .cta3 {
    padding-left: calc(24vw / 750 * 100);
    gap: calc(8vw / 750 * 100);
    right: calc(79vw / 750 * 100);
    left: auto;
  }
  .cta2:hover .cta__yaji {
    transform: translateX(calc(5vw / 750 * 100));
  }
  .cta2 .cta__yaji {
    max-width: calc(30vw / 750 * 100);
  }
  .cta2 .din-h-men {
    max-width: calc(176vw / 750 * 100);
  }
  .cta2 .din-h-women {
    max-width: calc(263vw / 750 * 100);
  }
  .cta3 .cta__yaji {
    top: calc(87vw / 750 * 100);
    right: calc(25vw / 750 * 100);
  }
}

.production__t1-span {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
}
</style>
